import React from 'react';
import { motion } from 'framer-motion';
export function Quote() {
  return <section className="relative py-32 md:py-40 px-6 md:px-12 bg-paper border-t border-b border-ink/10" data-id="element-182">
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 1
    }} className="relative max-w-2xl mx-auto text-center" data-id="element-183">
        <p className="eyebrow mb-10" data-id="element-184">For her —</p>
        <p className="font-serif-display text-ink text-3xl md:text-5xl leading-[1.15] italic" data-id="element-185">
          "I wish I had <br data-id="element-186" />
          the courage."
        </p>

        <motion.div initial={{
        scaleY: 0
      }} whileInView={{
        scaleY: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1.2,
        delay: 0.3
      }} style={{
        transformOrigin: 'top'
      }} className="mx-auto mt-12 w-px h-10 bg-sun/60" data-id="element-187" />

        <p className="mt-8 font-serif-display italic text-ink/60 text-base md:text-lg" data-id="element-188">
          You do not have to be fearless. <br data-id="element-189" />
          You just have to be curious.
        </p>
      </motion.div>
    </section>;
}